import { render, staticRenderFns } from "./BusinessUnits.vue?vue&type=template&id=0b5e3aee&scoped=true&"
import script from "./BusinessUnits.vue?vue&type=script&lang=js&"
export * from "./BusinessUnits.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnits.vue?vue&type=style&index=0&id=0b5e3aee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5e3aee",
  null
  
)

export default component.exports